module.exports = __webpack_public_path__ + "img/20190918155322350.9863eee0.jpg";